import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { SeedToSproutMorph } from '../components/SeedToSproutMorph';
interface Props {
  onContinue: () => void;
}
export function OnboardingStart({
  onContinue
}: Props) {
  const [animDone, setAnimDone] = useState(false);
  const [showTitle, setShowTitle] = useState(false);
  const [showSubtext, setShowSubtext] = useState(false);
  const [showButton, setShowButton] = useState(false);
  // Fade in elements alongside the sprout animation
  useEffect(() => {
    const t1 = setTimeout(() => setShowTitle(true), 500);
    const t2 = setTimeout(() => setShowSubtext(true), 800);
    const t3 = setTimeout(() => setShowButton(true), 1100);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);
  const handleAnimComplete = () => {
    setAnimDone(true);
  };
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] px-6 py-12" data-id="element-450">
      <div className="flex-1 flex flex-col items-center justify-center relative" data-id="element-451">
        {/* Subtle radial glow — appears after morph */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-[#C5D82D] blur-3xl rounded-full pointer-events-none transition-opacity duration-1000" style={{
        opacity: animDone ? 0.1 : 0
      }} data-id="element-452" />

        <div className="relative z-10 flex flex-col items-center gap-8 text-center w-full" data-id="element-453">
          {/* Morph Animation */}
          <SeedToSproutMorph onComplete={handleAnimComplete} data-id="element-454" />

          {/* Title — fades in while sprout is growing */}
          <div style={{
          opacity: showTitle ? 1 : 0,
          transform: showTitle ? 'translateY(0)' : 'translateY(10px)',
          transition: 'opacity 0.7s ease, transform 0.7s ease'
        }} data-id="element-455">
            <h1 className="text-[24px] font-medium text-white tracking-tight" data-id="element-456">
              Il tuo germoglio è pronto
            </h1>
          </div>

          {/* Subtext — fades in shortly after title */}
          <div style={{
          opacity: showSubtext ? 1 : 0,
          transform: showSubtext ? 'translateY(0)' : 'translateY(8px)',
          transition: 'opacity 0.7s ease, transform 0.7s ease',
          marginTop: '-16px'
        }} data-id="element-457">
            <p className="text-[15px] text-[#888888] max-w-[260px] leading-relaxed text-center" data-id="element-458">
              Raccontaci qualcosa di te per farlo crescere. Ci vorranno solo 2
              minuti.
            </p>
          </div>
        </div>
      </div>

      {/* Button — fades in while sprout finishes */}
      <div className="mt-auto pt-8 pb-4" style={{
      opacity: showButton ? 1 : 0,
      transform: showButton ? 'translateY(0)' : 'translateY(10px)',
      transition: 'opacity 0.7s ease, transform 0.7s ease'
    }} data-id="element-459">
        <button onClick={onContinue} disabled={!showButton} className="w-full bg-[#C5D82D] text-[#0D0D0D] rounded-full py-3.5 font-medium text-base transition-all duration-200 active:scale-[0.98] flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-460">
          Iniziamo
          <ArrowRight className="w-4 h-4" data-id="element-461" />
        </button>
      </div>
    </div>;
}